import ResponseMapperBase from './ResponseMapperBase';

export default class InformationContentResponseMapper extends ResponseMapperBase {
  mapResponse({ hasBeenOpened }: any) {
    return hasBeenOpened === false ? undefined : 100;
  }

  /**
   * @param {object} userAnswer
   */
  unMap(userAnswer: any) {
    return this.isAnsweredCorrectly(userAnswer) ? 100 : undefined;
  }
}
